import { TYPES } from './types'

export const setLoading = (value: boolean) => ({
  type: TYPES.SET_LOADING,
  value
})
